import { SERVICE_CONTRACT_TYPES } from '@common/utils'
import type {
  ServiceContractActions,
  ServiceContractState,
  StoreSlice
} from '../types'

export const createServiceContractSlice: StoreSlice<
  ServiceContractState & ServiceContractActions
> = set => ({
  // State
  selectedServiceContract: SERVICE_CONTRACT_TYPES.NONE,

  // Actions
  setSelectedServiceContract: val =>
    set({ selectedServiceContract: val }, false, 'setSelectedServiceContract')
})
